import { getLocale } from "../runtime";

const sv_nblanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Norsk`
};

const nblanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nblanguage(inputs)
	return "nbLanguage";
};

export { nblanguage as "nbLanguage" };